import { render, staticRenderFns } from "./Costruttori.vue?vue&type=template&id=481386ff&scoped=true&"
import script from "./Costruttori.vue?vue&type=script&lang=js&"
export * from "./Costruttori.vue?vue&type=script&lang=js&"
import style0 from "./Costruttori.vue?vue&type=style&index=0&id=481386ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481386ff",
  null
  
)

export default component.exports